var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelayedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 1.33333C4.32668 1.33333 1.33334 4.32666 1.33334 8C1.33334 11.6733 4.32668 14.6667 8.00001 14.6667C11.6733 14.6667 14.6667 11.6733 14.6667 8C14.6667 4.32666 11.6733 1.33333 8.00001 1.33333ZM10.6133 8.5H5.28001C5.00668 8.5 4.78001 8.27333 4.78001 8C4.78001 7.72666 5.00668 7.5 5.28001 7.5H10.6133C10.8867 7.5 11.1133 7.72666 11.1133 8C11.1133 8.27333 10.8933 8.5 10.6133 8.5Z",
    fill: "#DB6704"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelayedIcon);
export default __webpack_public_path__ + "static/media/delayed-icon.d376df2ff8c37150faf22adc2a680d2b.svg";
export { ForwardRef as ReactComponent };